export default __webpack_public_path__ + "static/article-saving-for-a-holiday-dd28ac036afadeaee6068034589bc970.jpg";